import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { protectedResources } from '../auth/auth.config';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ApiTokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // can extend this list as we add more backends
    const apiBases: string[] = [protectedResources.apiTodoList.endpoint];

    const needsAuth = this.isApiUrl(req.url, apiBases);

    let requestToSend = req;
    if (needsAuth && this.auth.isAuthenticated()) {
      const token = this.auth.getAccessToken();
      if (token) {
        requestToSend = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
      }
    }

    return next.handle(requestToSend).pipe(
      catchError((err: unknown) => {
        if (
          needsAuth &&
          err instanceof HttpErrorResponse &&
          err.status === 401
        ) {
          this.auth.handleUnauthorizedFromApi();
        }
        return throwError(() => err);
      }),
    );
  }

  private isApiUrl(url: string, bases: string[]): boolean {
    try {
      // Support both absolute and relative request URLs
      const u = new URL(url, window.location.origin);
      return bases.some((b) => u.href.startsWith(b));
    } catch {
      // If URL construction fails, play safe and don't attach
      return false;
    }
  }
}
